import WelcomeCard from './WelcomeCard';

export default WelcomeCard;
